/* KYstore — theme.js (vanilla, sans dépendance) */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var T = window.theme || {};
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat(T.locale || 'fr', { style: 'currency', currency: T.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function debounce(fn, wait) {
    var t;
    return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }

  /* ---------- Message (toast) ---------- */
  function toast(message, opts) {
    opts = opts || {};
    var el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = '';
    var span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (opts.href) {
      var a = document.createElement('a');
      a.href = opts.href;
      a.textContent = opts.label || 'Voir';
      el.appendChild(a);
    }
    el.classList.toggle('toast--error', !!opts.error);
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3800);
  }

  /* ---------- Menu ---------- */
  var menu = $('[data-menu]');
  function setMenu(open) {
    if (!menu) return;
    if (open) setSearch(false);
    menu.hidden = !open;
    document.body.classList.toggle('no-scroll', open);
  }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setMenu(true); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });

  /* ---------- Recherche plein écran ---------- */
  var search = $('[data-search]');
  var searchInput = $('[data-search-input]');
  var searchDefault = $('[data-search-default]');
  var searchResults = $('[data-search-results]');
  var searchBtn = $('[data-search-open]');

  function setSearch(open) {
    if (!search) return;
    if (open && menu) menu.hidden = true;
    search.hidden = !open;
    document.body.classList.toggle('no-scroll', open);
    if (searchBtn) searchBtn.classList.toggle('is-active', open);
    if (open && searchInput) searchInput.focus();
  }
  $$('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function () { setSearch(search.hidden); });
  });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { setSearch(false); }); });

  var runSuggest = debounce(function () {
    var q = searchInput.value.trim();
    if (q.length < 2) {
      searchResults.innerHTML = '';
      if (searchDefault) searchDefault.hidden = false;
      return;
    }
    var url = T.routes.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (searchDefault) searchDefault.hidden = true;
        if (!products.length) {
          searchResults.innerHTML = '<p class="muted">Aucun résultat pour « ' + esc(q) + ' ».</p>';
          return;
        }
        searchResults.innerHTML =
          '<ul class="suggest">' +
          products.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            return '<li><a href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="" width="64" height="80" loading="lazy">' : '<span class="suggest__noimg"></span>') +
              '<span>' + esc(p.title) + '</span>' +
              '<span class="muted">' + esc(money(parseFloat(p.price) * 100)) + '</span>' +
              '</a></li>';
          }).join('') +
          '</ul><a class="link-arrow" href="' + T.routes.root + 'search?q=' + encodeURIComponent(q) + '&type=product">Voir tous les résultats</a>';
      })
      .catch(function () { /* silencieux : la recherche classique fonctionne toujours */ });
  }, 250);
  if (searchInput) searchInput.addEventListener('input', runSuggest);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setMenu(false); setSearch(false); document.body.classList.remove('filters-open'); }
  });

  /* ---------- Panier : compteur + ajout ---------- */
  function refreshCartCount() {
    return fetch(T.routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  function addToCart(body) {
    return fetch(T.routes.cartAdd + '.js', body).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || "Impossible d'ajouter ce produit.");
        return data;
      });
    });
  }

  function afterAdd() {
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    return refreshCartCount().then(function () {
      toast('Ajouté au panier', { href: T.routes.cart, label: 'Voir le panier' });
    });
  }

  /* Fiche produit (formulaire) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-product-form]') : null;
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-add]', form);
    var label = $('[data-add-label]', form);
    var original = label ? label.textContent : '';
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (label) label.textContent = 'Ajout…';

    addToCart({ method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(afterAdd)
      .catch(function (err) { toast(err.message, { error: true }); })
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (label) label.textContent = original;
      });
  });

  /* Boutons « Ajouter au panier » et « + » des cartes */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-quick-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    addToCart({ method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] }) })
      .then(afterAdd)
      .catch(function (err) { toast(err.message, { error: true }); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  });

  /* ---------- Quantité (fiche produit + panier) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest ? e.target.closest('[data-qty-step]') : null;
    if (!step) return;
    var input = $('input', step.closest('.qty'));
    var isCart = input.hasAttribute('data-cart-qty');
    var min = isCart ? 0 : 1;
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
    if (isCart) input.form.submit();
  });
  $$('[data-cart-qty]').forEach(function (i) {
    i.addEventListener('change', function () { i.form.submit(); });
  });

  /* ---------- Panier : changer taille / couleur ---------- */
  $$('[data-cart-option]').forEach(function (sel) {
    sel.dataset.current = sel.value;
    sel.addEventListener('change', function () {
      var row = sel.closest('.cart-item');
      var selects = $$('[data-cart-option]', row);
      var values = selects.map(function (s) { return s.value; });
      var qty = parseInt(row.dataset.qty, 10) || 1;
      var revert = function () { selects.forEach(function (s) { s.value = s.dataset.current; }); };
      row.style.opacity = '.6';

      fetch(T.routes.root + 'products/' + row.dataset.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var v = p.variants.filter(function (v) {
            return v.options.every(function (o, i) { return o === values[i]; });
          })[0];
          if (!v) { toast("Cette combinaison n'existe pas.", { error: true }); revert(); return; }
          if (!v.available) { toast('Cette version est épuisée.', { error: true }); revert(); return; }
          return addToCart({ method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] }) })
            .then(function () {
              return fetch(T.routes.cartChange + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: row.dataset.lineKey, quantity: 0 }) });
            })
            .then(function () { location.reload(); });
        })
        .catch(function (err) { toast(err.message || 'Impossible de modifier cet article.', { error: true }); revert(); })
        .then(function () { row.style.opacity = ''; });
    });
  });

  /* ---------- Fiche produit : variantes ---------- */
  function initProduct(root) {
    var json = $('[data-product-json]', root);
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var form = $('form[data-product-form]', root);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-add]', form);
    var label = $('[data-add-label]', form);
    var priceEl = $('[data-price]', root);
    var fieldsets = $$('[data-option-index]', root);
    var mobile = window.matchMedia('(max-width: 989px)');

    function priceHTML(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        return '<div class="price price--sale"><s class="price__compare">' + money(v.compare_at_price) + '</s><span class="price__current">' + money(v.price) + '</span></div>';
      }
      return '<div class="price"><span class="price__current">' + money(v.price) + '</span></div>';
    }

    function update() {
      var variant;
      if (!fieldsets.length) {
        variant = data.variants[0];
      } else {
        var chosen = fieldsets.map(function (fs) {
          var c = $('input:checked', fs);
          var out = $('[data-option-value]', fs);
          if (out && c) out.textContent = c.value;
          return c ? c.value : null;
        });
        variant = data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        })[0];
      }
      if (!variant) { btn.disabled = true; label.textContent = 'Indisponible'; return; }

      idInput.value = variant.id;
      btn.disabled = !variant.available;
      label.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      priceEl.innerHTML = priceHTML(variant);
      if (window.history && history.replaceState) history.replaceState(null, '', '?variant=' + variant.id);
      if (variant.featured_media && mobile.matches) {
        var m = $('[data-media-id="' + variant.featured_media.id + '"]', root);
        if (m && m.scrollIntoView) m.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- Filtres collection ---------- */
  $$('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { if (el.form) el.form.submit(); });
  });
  $$('[data-filters-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { document.body.classList.toggle('filters-open'); });
  });

  /* ---------- Favoris (enregistrés sur l'appareil) ---------- */
  var FAV_KEY = 'kystore:favs';
  var HEART = '<svg class="icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7.5-4.6-9.3-9.5C1.5 7.2 3.6 4 7 4c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.4 0 5.5 3.2 4.3 6.5C19.5 15.4 12 20 12 20z"/></svg>';
  var productCache = {};
  var favSort = 'recent';

  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function setFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) { /* stockage indisponible */ }
    updateFavUI();
    renderFavorites();
  }
  function updateFavUI() {
    var favs = getFavs();
    $$('[data-fav-toggle]').forEach(function (b) {
      var on = favs.indexOf(b.dataset.handle) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-fav-toggle]') : null;
    if (!b) return;
    e.preventDefault();
    var favs = getFavs();
    var i = favs.indexOf(b.dataset.handle);
    if (i === -1) { favs.push(b.dataset.handle); } else { favs.splice(i, 1); }
    setFavs(favs);
  });

  function imgUrl(u, w) { return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }

  function favCard(p) {
    var img = p.featured_image
      ? '<img class="card__img" src="' + esc(imgUrl(p.featured_image, 700)) + '" alt="' + esc(p.title) + '" loading="lazy" width="700" height="875">'
      : '';
    var action;
    if (!p.available) {
      action = '<span class="btn btn--sm btn--block is-disabled">Épuisé</span>';
    } else if (p.variants.length === 1) {
      action = '<button type="button" class="btn btn--sm btn--block" data-quick-add data-variant-id="' + p.variants[0].id + '">Ajouter au panier</button>';
    } else {
      action = '<a class="btn btn--sm btn--block" href="' + esc(p.url) + '">Voir les options</a>';
    }
    return '<article class="card">' +
      '<div class="card__frame"><a class="card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<button type="button" class="fav is-active" data-fav-toggle data-handle="' + esc(p.handle) + '" aria-pressed="true" aria-label="Retirer ' + esc(p.title) + ' des favoris">' + HEART + '</button></div>' +
      '<div class="card__body"><a class="card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="price"><span class="price__current">' + (p.price_varies ? 'À partir de ' : '') + esc(money(p.price)) + '</span></div></div>' +
      action + '</article>';
  }

  function renderFavorites() {
    var grid = $('[data-favorites-grid]');
    if (!grid) return;
    var empty = $('[data-favorites-empty]');
    var count = $('[data-favorites-count]');
    var handles = getFavs().slice().reverse(); /* plus récents en premier */
    if (empty) empty.hidden = handles.length > 0;
    if (count) count.textContent = handles.length + ' article' + (handles.length > 1 ? 's' : '');

    Promise.all(handles.map(function (h) {
      if (productCache[h]) return Promise.resolve(productCache[h]);
      return fetch(T.routes.root + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) productCache[h] = p; return p; })
        .catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (favSort === 'price-asc') items.sort(function (a, b) { return a.price - b.price; });
      if (favSort === 'price-desc') items.sort(function (a, b) { return b.price - a.price; });
      if (favSort === 'name') items.sort(function (a, b) { return a.title.localeCompare(b.title, 'fr'); });
      grid.innerHTML = items.map(favCard).join('');
      updateFavUI();
    });
  }

  var sortSel = $('[data-favorites-sort]');
  if (sortSel) sortSel.addEventListener('change', function () { favSort = sortSel.value; renderFavorites(); });

  updateFavUI();
  renderFavorites();
})();
